import { useTheme } from 'contexts'
import { useWindowDimensions } from 'react-native'

// Calculates the value of a single dimension for a given aspect ratio
export const useMaxWidth = () => {
  const { maxWidth } = useTheme()
  const window = useWindowDimensions()

  return {
    width: Math.min(window.width, maxWidth),
    height: window.height,
  }
}
